const SkillData = [
    {
        id: 1,
        percentage: '65%',
        value: 65,
        title: 'UX Design',
    },
    {
        id: 2,
        percentage: '73%',
        value: 73,
        title: 'Language Skill',
    },
    {
        id: 3,
        percentage: '95%',
        value: 95,
        title: 'Web development',
    }
]

export default SkillData